import React, { ChangeEvent, Component } from "react";
import IErrorDTO from "../../../../../models/DTO/IErrorDTO";
import IGetWarehousesDTO from "../../../../../models/DTO/IGetWarehousesDTO";
import IOnGetWarehousesDTO from "../../../../../models/DTO/IOnGetWarehousesDTO";
import EndpointsEnum from "../../../../../models/EndpointsEnum";
import ICatalog_ItemUI from "../../../../../models/ICatalog_ItemUI";
import ISupplierModel from "../../../../../models/ISupplierModel";
import IUserUI from "../../../../../models/IUser";
import IWarehouse from "../../../../../models/IWarehouse";
import IWarehouseItem from "../../../../../models/IWarehouseItem";
import OwButton from "../../../../shared/OwButton/OwButton";
import OwInputWrapper from "../../../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../../../shared/OwLabel/OwLabel";
import OwStaticTypeahead from "../../../../shared/OwStaticTypeahead/OwStaticTypeahead";
import { OwFnInput } from "../../../../shared/OwFnInput/OwFnInput";
import { Socket } from "socket.io-client";

type Props = {
    warehouseMap: IWarehouseItem[];
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    socket: Socket;
    catalog_item?: ICatalog_ItemUI;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    updateWarehouseMapFn: (warehouseMap: IWarehouseItem[]) => void;
};

type State = {
    warehouses: IWarehouse[];
    selectedWarehouse?: IWarehouse;
    warehouseMap: IWarehouseItem[];
    performUpdate: boolean;
    clearTypeahead: boolean;
};

class WarehouseDetail extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            warehouses: [],
            warehouseMap: this.props.warehouseMap,
            performUpdate: false,
            clearTypeahead: false,
        };
    }

    componentDidMount() {
        this.props.socket.on(EndpointsEnum.WarehouseOnGetWarehouses, this.onGetWarehouses);

        this.getWarehouses();
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if (prevState.performUpdate || prevProps.warehouseMap.length !== this.props.warehouseMap.length) {
            this.setState({
                warehouseMap: this.props.warehouseMap,
                performUpdate: false,
            });
        }
    }

    componentWillUnmount() {
        this.props.socket.removeListener(EndpointsEnum.WarehouseOnGetWarehouses, this.onGetWarehouses);
    }

    getWarehouses = () => {
        const payload: IGetWarehousesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.WarehouseGetWarehouses, payload);
    };

    onGetWarehouses = (data: IOnGetWarehousesDTO) => {
        this.setState({
            warehouses: data.warehouses,
        });
    };

    selectWarehouse = (warehouse: IWarehouse) => {
        this.setState({
            selectedWarehouse: warehouse,
        });
    };

    addWarehouse = () => {
        const warehouseMap = this.state.warehouseMap || [];

        warehouseMap.push({
            warehouse_id: this.state.selectedWarehouse!.id,
            Warehouse: this.state.selectedWarehouse,
            qty_on_hand: 0,
            min_qty_on_hand: 0,
            bin: "",
            row: "",
        });

        this.setState(
            {
                warehouseMap,
                performUpdate: true,
                selectedWarehouse: undefined,
                clearTypeahead: true,
            },
            () => {
                this.props.updateWarehouseMapFn(this.state.warehouseMap);
            }
        );
    };

    handleChange = (e: ChangeEvent<any>, mapDetail: IWarehouseItem) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const warehouseMap = this.state.warehouseMap;

        for (const mapItem of warehouseMap) {
            if (mapItem.warehouse_id === mapDetail.warehouse_id) {
                // @ts-expect-error
                mapItem[name] = value;
            }
        }

        this.setState(
            {
                warehouseMap,
                performUpdate: true,
            },
            () => {
                this.props.updateWarehouseMapFn(this.state.warehouseMap);
            }
        );
    };

    deleteWarehouse = (mapDetail: IWarehouseItem) => {
        const warehouseMap = this.state.warehouseMap;

        for (const mapItem of warehouseMap) {
            if (mapItem.warehouse_id === mapDetail.warehouse_id) {
                mapItem.deleteFlag = !mapItem.deleteFlag;
            }
        }

        this.setState(
            {
                warehouseMap,
                performUpdate: true,
            },
            () => {
                this.props.updateWarehouseMapFn(this.state.warehouseMap);
            }
        );
    };

    clearTypeaheadFn = () => {
        this.setState({
            clearTypeahead: false,
        });
    };

    render() {
        return (
            <div className="WarehouseDetail p-2 border-primary border">
                <OwLabel title={"warehouses"} noBottomMargin={true} />
                <div className={"d-flex"}>
                    <div className={"flex-grow"}>
                        <OwStaticTypeahead
                            isSelectableFn={() => {
                                return true;
                            }}
                            selectedItemValueProp={"id"}
                            selectedItemFn={this.selectWarehouse}
                            selectedItemTitleProp={"name"}
                            typeaheadItems={this.state.warehouses}
                            selectedItem={this.state.selectedWarehouse}
                            titleProp={"name"}
                            clearTypeahead={this.state.clearTypeahead}
                            clearTypeaheadCallback={this.clearTypeaheadFn}
                        />
                    </div>
                    <div>
                        <OwButton title={"add"} fn={this.addWarehouse} disabled={!this.state.selectedWarehouse} />
                    </div>
                </div>
                <div>
                    {this.state.warehouseMap?.map((mapDetail) => {
                        return (
                            <table key={mapDetail.id} className={"mt-2"}>
                                <tr>
                                    <th></th>
                                    <th>
                                        <OwLabel title={"warehouse"} />
                                    </th>
                                    <th>
                                        <OwLabel title={"qoh"} />
                                    </th>
                                    <th>
                                        <OwLabel title={"row"} />
                                    </th>
                                    <th>
                                        <OwLabel title={"bin"} />
                                    </th>
                                </tr>
                                <tr>
                                    <td className={"w-2r"}>
                                        <i
                                            className={"fas fa-trash-alt text-danger pointer"}
                                            onClick={() => {
                                                this.deleteWarehouse(mapDetail);
                                            }}
                                        />
                                    </td>
                                    <td className={"w-10r " + (mapDetail.deleteFlag ? "text-strikethrough" : "")}>
                                        {mapDetail.Warehouse?.name}
                                    </td>
                                    <td className={"w-6r"}>
                                        <OwFnInput
                                            type={"number"}
                                            name={"qty_on_hand"}
                                            value={mapDetail.qty_on_hand}
                                            fn={(e: any) => {
                                                this.handleChange(e, mapDetail);
                                            }}
                                            disabled={mapDetail.deleteFlag}
                                        />
                                    </td>
                                    <td className={"w-4r"}>
                                        <OwInputWrapper
                                            name={"row"}
                                            value={mapDetail.row}
                                            fn={(e: any) => {
                                                this.handleChange(e, mapDetail);
                                            }}
                                            disabled={mapDetail.deleteFlag}
                                        />
                                    </td>
                                    <td className={"w-4r"}>
                                        <OwInputWrapper
                                            name={"bin"}
                                            value={mapDetail.bin}
                                            fn={(e: any) => {
                                                this.handleChange(e, mapDetail);
                                            }}
                                            disabled={mapDetail.deleteFlag}
                                        />
                                    </td>
                                </tr>
                            </table>
                        );
                    })}
                </div>
            </div>
        );
    }
}

export default WarehouseDetail;
